var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.SideMenuDrawer, {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ counterXSpaceClass, counterYSpaceClass }) {
              return [
                _c(_setup.SideMenuContent, {
                  attrs: {
                    "list-class": [counterXSpaceClass, counterYSpaceClass],
                    "hide-town-select": _setup.hideTownSelect,
                    town: _setup.town,
                    "town-select-url": _setup.townSelectUrl,
                    "expert-url": _setup.expertUrl,
                    "personal-area-url": _setup.personalAreaUrl,
                    projects: _setup.projects,
                  },
                  on: {
                    "open-languages": _setup.openLanguagesBottomSheet,
                    "open-projects": _setup.openOurProjectsDialog,
                    "open-town": _setup.openTownDialog,
                    logout: _setup.handleLogout,
                    "click-card-info": _setup.handleClickCardInfo,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _setup.isActive,
          callback: function ($$v) {
            _setup.isActive = $$v
          },
          expression: "isActive",
        },
      }),
      _vm._v(" "),
      _c(_setup.SideMenuLanguageSheet, {
        attrs: { languages: _setup.availableLanguages },
        model: {
          value: _setup.isLanguageBottomPannelOpen,
          callback: function ($$v) {
            _setup.isLanguageBottomPannelOpen = $$v
          },
          expression: "isLanguageBottomPannelOpen",
        },
      }),
      _vm._v(" "),
      _setup.hasWindow && _setup.projects
        ? _c(_setup.OurProjectsDialogComponent, {
            tag: "component",
            attrs: { projects: _setup.projects },
            model: {
              value: _setup.isActiveOurProjectsDialog,
              callback: function ($$v) {
                _setup.isActiveOurProjectsDialog = $$v
              },
              expression: "isActiveOurProjectsDialog",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.hasWindow
        ? _c(_setup.HeaderTown, {
            attrs: { "hide-trigger": "" },
            model: {
              value: _setup.isTownDialogActive,
              callback: function ($$v) {
                _setup.isTownDialogActive = $$v
              },
              expression: "isTownDialogActive",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.hasWindow
        ? _c(_setup.LogoutDialog, {
            on: { confirm: _setup.logout },
            model: {
              value: _setup.isLogoutDialogActive,
              callback: function ($$v) {
                _setup.isLogoutDialogActive = $$v
              },
              expression: "isLogoutDialogActive",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.CoreSnackbar),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }